import React from 'react'
// libs
import { FieldArray } from 'redux-form'
// components
import AccessList from './components/AccessList'

interface Props {
  field: string
}

const AccessFromRelatedForm: React.FC<Props> = ({ field }) => {
  return <FieldArray component={AccessList} name={`${field}.relatedFormAccessList`} />
}

export default AccessFromRelatedForm
